export class GoogleWorkspaceUserRestoreSelection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ownerId",
            "baseName": "ownerId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceUserRestoreSelection.attributeTypeMap;
    }
    constructor() {
    }
}
